export default __webpack_public_path__ + "7b09e1db1ee6e20c44c8a45a3edf7b7a.svg";